import { Field, ObjectType } from '@nestjs/graphql'

@ObjectType()
export class KvpDto {
  @Field(type => String)
  key!: string

  @Field(type => String)
  value!: string
}
